export default __webpack_public_path__ + "static/media/services.65841a05.svg";